import type { NormalizedRect, PixelRect } from '@/domain/types'

export function clampRect(rect: NormalizedRect): NormalizedRect {
  const x = Math.min(1, Math.max(0, rect.x))
  const y = Math.min(1, Math.max(0, rect.y))
  return {
    x,
    y,
    width: Math.min(1 - x, Math.max(0.002, rect.width)),
    height: Math.min(1 - y, Math.max(0.002, rect.height)),
  }
}
export function toPixelRect(rect: NormalizedRect, width: number, height: number): PixelRect {
  const safe = clampRect(rect)
  return {
    x: Math.round(safe.x * width),
    y: Math.round(safe.y * height),
    width: Math.max(1, Math.round(safe.width * width)),
    height: Math.max(1, Math.round(safe.height * height)),
  }
}

export function composeRect(parent: NormalizedRect, child: NormalizedRect): NormalizedRect {
  return clampRect({
    x: parent.x + child.x * parent.width,
    y: parent.y + child.y * parent.height,
    width: parent.width * child.width,
    height: parent.height * child.height,
  })
}

export function median(values: readonly number[]): number | null {
  if (!values.length) return null
  const sorted = [...values].sort((a, b) => a - b)
  const middle = Math.floor(sorted.length / 2)
  if (sorted.length % 2) return sorted[middle] ?? null
  return ((sorted[middle - 1] ?? 0) + (sorted[middle] ?? 0)) / 2
}
